/** Limites do relato. O cliente usa para o `maxLength`, o servidor para recusar. */
export const DESCRIPTION_MIN_LENGTH = 10
export const DESCRIPTION_MAX_LENGTH = 2000
export const EXPECTED_MAX_LENGTH = 1000

/** Tetos do diagnóstico. Passar disso é truncado, nunca recusado. */
export const URL_MAX_LENGTH = 500
export const USER_AGENT_MAX_LENGTH = 300
export const SHORT_FIELD_MAX_LENGTH = 60

/**
 * Ligado por padrão: o app inteiro está em beta e o público hoje é justamente
 * quem precisa reportar. O env var existe para desligar sem deploy de código
 * quando o beta acabar — `BUG_REPORT_ENABLED=false`.
 *
 * Lido no Server Component do layout raiz; não é `NEXT_PUBLIC_` de propósito,
 * então não vale a pena chamar daqui de dentro de componente cliente (no bundle
 * do browser a variável não existe e a função responderia "ligado").
 */
export function isBugReportEnabled(): boolean {
  return process.env.BUG_REPORT_ENABLED !== "false"
}
